import {Data, RecordProps} from '@store/@types/util';
import dayjs, {Dayjs} from 'dayjs';
import {UserId} from 'records/User';
import {CallActivityItem} from '@store/call-card/CallActivityItem';
import {List} from 'immutable';

interface UserCallActivityInterface {
  lastActivityDate: Dayjs;
  actionUser: ActionUser;
  items: List<CallActivityItem>;
}

export class UserCallActivity extends Data<UserCallActivityInterface>({
  lastActivityDate: undefined,
  actionUser: undefined,
  items: undefined,
}) {
  constructor(props: RecordProps<UserCallActivityInterface>) {
    const items = props.items?.map(i => ({
      ...i,
      timestamp: dayjs(i.timestamp),
    }));

    super({
      lastActivityDate: dayjs(props.lastActivityDate),
      actionUser: props.actionUser,
      items: List(items ?? []),
    });
  }
}

interface ActionUser {
  id: UserId;
  firstName: string;
  lastName: string;
  avatar: string;
  color: string;
}
